import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'dpl/common/components/Icon';
import { sendRudderstackEvent } from 'dpl/util/analytics';
import {
  ANALYTICS_EVENTS,
  ANALYTICS_VIEWS,
  ANALYTICS_VIEW_FEATURES,
  ANALYTICS_VIEW_FEATURE_LOCATIONS
} from 'dpl/constants/analytics';
import { RESULTS_TYPES } from 'dpl/puppy_search_results/utils/constants';

import useSearchFiltering from '../hooks/useSearchFiltering';
import FiltersModal from './FiltersModal';

export default function ExposedFilterMenu({ resultsType, totalItemCount }) {
  const { toggleFilters } = useSearchFiltering();

  function handleFilterButtonClick(e) {
    toggleFilters();
    sendRudderstackEvent(ANALYTICS_EVENTS.BUTTON_CLICKED, {
      button_cta: e.target.textContent,
      view:
        resultsType === RESULTS_TYPES.PUPPIES
          ? ANALYTICS_VIEWS.PUPPY_SEARCH_RESULTS
          : ANALYTICS_VIEWS.BREEDER_SEARCH_RESULTS,
      view_feature: ANALYTICS_VIEW_FEATURES.SORT_FILTER_BUTTON,
      view_feature_location: ANALYTICS_VIEW_FEATURE_LOCATIONS.SEARCH_HEADER
    });
  }

  return (
    <div className="SearchResultsMobileFilterMenu">
      <button
        className="dib bg-white br1"
        type="button"
        onClick={handleFilterButtonClick}
      >
        <span className="flex nowrap items-center br1 b--default pv2 pl3 ba secondary pr3">
          <Icon
            className="mr2 tertiary"
            name="fetch-filter"
            width="24px"
            height="24px"
          />
          <span className="font-14 fw-medium">All filters</span>
        </span>
      </button>
      <FiltersModal totalItemCount={totalItemCount} />
    </div>
  );
}

ExposedFilterMenu.propTypes = {
  resultsType: PropTypes.string.isRequired,
  totalItemCount: PropTypes.number.isRequired
};
